import React from 'react';

import Link from './Link';

import useLinks from './hooks/useLinks';

export default function Sidebar() {
  const links = useLinks();

  return (
    <div className="overflow-y-auto z-30 py-5 px-3 w-16 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <ul className="space-y-2">
        {links.map((link, index) => {
          return <Link key={index} url={link?.url} icon={link?.icon} />;
        })}
      </ul>
    </div>
  );
}
